import * as zod from 'zod';

export default zod.object({
  confirmed: zod.boolean(),
});
